// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WeZqU3Mwc9I1SB {
  display: flex;
  position: fixed;
  flex-direction: column;
  inset: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WeZqU3Mwc9I1SB`
};
export default ___CSS_LOADER_EXPORT___;
